// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-sps-10-adult-motorcycle-riding-gloves-breathable-durable-anti-slip-touchscreen-leather-gloves-for-spring-summer-and-fall-copy",
  "entries": [
    {
      "id": "33461545140414",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps10-white-white-background-main-20260717.jpg?v=1784265502",
      "alt": "color:White | batch:sps10-whitebg-20260717 | role:white-background-main | Seibertron SPS-10 white white background main image"
    },
    {
      "id": "33374625300670",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-01.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 01"
    },
    {
      "id": "33374625333438",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-02.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 02"
    },
    {
      "id": "33374625366206",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-03.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 03"
    },
    {
      "id": "33374625398974",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-04.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 04"
    },
    {
      "id": "33374625431742",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-05.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 05"
    },
    {
      "id": "33374625464510",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-06.jpg?v=1783398444",
      "alt": "color:White | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 06"
    },
    {
      "id": "33461828976830",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps10-black-white-background-main-20260717.jpg?v=1784272334",
      "alt": "color:Black | batch:sps10-black-green-whitebg-20260717 | role:white-background-main | Seibertron SPS-10 black white background main image"
    },
    {
      "id": "33374625497278",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-07.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 07"
    },
    {
      "id": "33374625530046",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-08.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 08"
    },
    {
      "id": "33374625562814",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-09.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 09"
    },
    {
      "id": "33374625595582",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-10.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 10"
    },
    {
      "id": "33374625628350",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-11.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 11"
    },
    {
      "id": "33374625661118",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-12.jpg?v=1783398444",
      "alt": "color:Black | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 12"
    },
    {
      "id": "33374625693886",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-13.jpg?v=1783398444",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 13"
    },
    {
      "id": "33374625726654",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-14.jpg?v=1783398444",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 14"
    },
    {
      "id": "33374625759422",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-15.jpg?v=1783398444",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 15"
    },
    {
      "id": "33374625792190",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-16.jpg?v=1783398445",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 16"
    },
    {
      "id": "33374625824958",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-17.jpg?v=1783398444",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 17"
    },
    {
      "id": "33374625857726",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-18.jpg?v=1783398444",
      "alt": "color:Gray | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 18"
    },
    {
      "id": "33461829009598",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps10-green-white-background-main-20260717.jpg?v=1784272334",
      "alt": "color:Green | batch:sps10-black-green-whitebg-20260717 | role:white-background-main | Seibertron SPS-10 green white background main image"
    },
    {
      "id": "33374625890494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-19.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 19"
    },
    {
      "id": "33374625923262",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-20.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 20"
    },
    {
      "id": "33374625956030",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-21.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 21"
    },
    {
      "id": "33374625988798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-22.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 22"
    },
    {
      "id": "33374626021566",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-23.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 23"
    },
    {
      "id": "33374626054334",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps10-leather-riding-gallery-24.jpg?v=1783398444",
      "alt": "color:Green | Seibertron SPS-10 breathable anti-slip touchscreen leather motorcycle gloves image 24"
    }
  ],
  "variants": [
    {
      "id": "45294986920126",
      "title": "White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "White",
        "Adult S"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294986952894",
      "title": "White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "White",
        "Adult M"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294986985662",
      "title": "White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "White",
        "Adult L"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294987018430",
      "title": "White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "White",
        "Adult XL"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294987051198",
      "title": "White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "White",
        "Adult XXL"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996455614",
      "title": "White / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "White",
        "Adult XXXL"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996488382",
      "title": "White / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "White",
        "Youth XS"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996521150",
      "title": "White / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "White",
        "Youth S"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996553918",
      "title": "White / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "White",
        "Youth M"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996586686",
      "title": "White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "White",
        "Youth L"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294996619454",
      "title": "White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "White",
        "Youth XL"
      ],
      "mediaId": "33461545140414"
    },
    {
      "id": "45294987116734",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294987149502",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294987182270",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294987215038",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294987247806",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996652222",
      "title": "Black / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXXL"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996684990",
      "title": "Black / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Black",
        "Youth XS"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996717758",
      "title": "Black / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Black",
        "Youth S"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996750526",
      "title": "Black / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Black",
        "Youth M"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996783294",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294996816062",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33461828976830"
    },
    {
      "id": "45294987313342",
      "title": "Gray / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Gray",
        "Adult S"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294987346110",
      "title": "Gray / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Gray",
        "Adult M"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294987378878",
      "title": "Gray / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Gray",
        "Adult L"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294987411646",
      "title": "Gray / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Gray",
        "Adult XL"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294987444414",
      "title": "Gray / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Gray",
        "Adult XXL"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294996848830",
      "title": "Gray / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Gray",
        "Adult XXXL"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294996881598",
      "title": "Gray / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Gray",
        "Youth XS"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294996914366",
      "title": "Gray / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Gray",
        "Youth S"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294996947134",
      "title": "Gray / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Gray",
        "Youth M"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294996979902",
      "title": "Gray / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Gray",
        "Youth L"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294997012670",
      "title": "Gray / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gray"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Gray",
        "Youth XL"
      ],
      "mediaId": "33374625693886"
    },
    {
      "id": "45294987509950",
      "title": "Green / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Green",
        "Adult S"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294987542718",
      "title": "Green / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Green",
        "Adult M"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294987575486",
      "title": "Green / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Green",
        "Adult L"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294987608254",
      "title": "Green / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Green",
        "Adult XL"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294987641022",
      "title": "Green / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Green",
        "Adult XXL"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997045438",
      "title": "Green / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Green",
        "Adult XXXL"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997078206",
      "title": "Green / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Green",
        "Youth XS"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997110974",
      "title": "Green / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Green",
        "Youth S"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997143742",
      "title": "Green / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Green",
        "Youth M"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997176510",
      "title": "Green / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Green",
        "Youth L"
      ],
      "mediaId": "33461829009598"
    },
    {
      "id": "45294997209278",
      "title": "Green / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Green",
        "Youth XL"
      ],
      "mediaId": "33461829009598"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
